<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="white-card">
        <div class="header-title-row">
          <div class="header-left">
            <img
              src="assets/svg/contract-icon.svg"
              alt="Prospectos"
              class="center-svg"
            />
            <h1 class="text-semibold color-org t-24">Contratos</h1>
            <div class="dropdown-wrapper" #dropdownContainer>
              <div class="dropdown-trigger" (click)="toggleRecentDropdown()">
                <span>
                  {{selectedItem === 'todos' ? 'Ver todos' : selectedItem ===
                  'propios' ? 'Ver propios' : 'ver todos' }}
                </span>
                <span [class.rotated]="showRecentDropdown">▼</span>
                <div class="dropdown-menu" [class.show]="showRecentDropdown">
                  <button
                    class="dropdown-item"
                    [class.selected]="selectedItem === 'todos'"
                    (click)="selectItem('todos'); $event.stopPropagation()"
                  >
                    <span class="check-icon" *ngIf="selectedItem === 'todos'"
                      >✔</span
                    >Ver todos
                  </button>
                  <button
                    class="dropdown-item"
                    [class.selected]="selectedItem === 'propios'"
                    (click)="selectItem('propios'); $event.stopPropagation()"
                  >
                    <span class="check-icon" *ngIf="selectedItem === 'propios'"
                      >✔</span
                    >
                    Ver propios
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="header-actions">
            <button
              *ngIf="permissionService.hasPermission('Contratos','Crear')"
              class="action-btn primary"
              (click)="openMdlCreateContract()"
            >
              <img
                src="assets/svg/plus-icon.svg"
                alt="Añadir nuevo"
                width="16"
                height="16"
              />
              Añadir nuevo
            </button>
          </div>
        </div>

        <div
          class="header-stats mt-3"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div class="header-stats mt-3">
            <span
              >{{contratos.length}} elementos | Se actualizó hace 2
              minutos</span
            >
          </div>
          <div
            *ngIf="contratosSeleccionados > 0"
            style="display: flex; align-items: center; gap: 10px"
          >
            <span class="selection-count" style="font-weight: 500">
              {{ contratosSeleccionados }} Usuarios seleccionados
            </span>

            <div class="actions-container" style="position: relative">
              <div (click)="toggleActionsDropdown()" class="actions-dropdown">
                <span>Seleccionar acción</span>
                <span [class.rotated]="showActionsDropdown"></span>
                <img
                  src="assets/svg/arrow-down-black.svg"
                  class="sort-icon"
                  style="width: 12px; height: 12px"
                />
              </div>

              <div *ngIf="showActionsDropdown" class="dropdown-content">
                <a (click)="ejecutarAccion('descargar')" class="dropdown-item"
                  >Descargar contratos</a
                >
                <a *ngIf="permissionService.hasPermission('Contratos','Eliminar')" (click)="ejecutarAccion('eliminar')" class="dropdown-item"
                  >Eliminar contratos</a
                >
                <a *ngIf="permissionService.hasPermission('Contratos','Editar')" (click)="ejecutarAccion('cambiar')" class="dropdown-item"
                  >Cambiar propietario</a
                >
                <a (click)="ejecutarAccion('asignar')" class="dropdown-item"
                  >Asignar recordatorio</a
                >
                <a *ngIf="permissionService.hasPermission('Contratos','Cambiar etapa')" (click)="ejecutarAccion('estado')" class="dropdown-item"
                  >Cambiar estado</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="content-area mt-5">
          <div *ngIf="errorMessage" class="error-message">{{errorMessage}}</div>
          <div *ngIf="!isLoading && contratos.length > 0">
            <div class="d-grid search-bar-container" style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  width: 100%;
                  gap: 16px;
                ">
              <div class="npt-table-search-bar d-grid" style="flex: 1; min-width: 0">
                <div><img src="assets/svg/search.svg" alt="" /></div>
                <input
                  type="text"
                  class="npt-nav-search"
                  placeholder="Buscar en esta lista..."
                  style="flex: 1; min-width: 0; width: 100%"
                  [(ngModel)]="searchTerm"
                  (input)="onSearchChange()"
                />
              </div>
              <div style="display: flex; gap: 12px; flex-shrink: 0">
                <button
                  class="search-btn"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    white-space: nowrap;
                  "
                (click)="actualizarTabla()">
                  <img src="assets/svg/reload-icon.svg" alt="Actualizar" />
                  <span>Actualizar</span>
                </button>
                <button
                  class="search-btn"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    white-space: nowrap;
                  "
                >
                  <img src="assets/svg/filtrar-icon.svg" alt="Filtrar" />
                  <span>Filtrar</span>
                </button>
              </div>
            </div>
            <div class="prospectos-table mh-50">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th class="checkbox-column text-center">
                      <img src="assets/svg/checkline-icon.svg" />
                    </th>
                    <th >Numero de contrato</th>
                    <th>Orden de compra</th>
                    <th>Nombre de la cuenta</th>
                    <th>Fecha de Inicio</th>
                    <th>Fecha de expiración</th>
                    <th>Estado</th>
                    <th>Duracion de contrato</th>
                    <th>Recordatorio</th>
                    <th>Asignado a</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let contrato of contratosfiltrados; let i = index"
                    (click)="verDetalleContrato(contrato.contrato_id, $event)"
                  >
                    <td class="counter-cell">{{ i + 1 }}.</td>
                    <td class="checkbox-column">
                      <input
                        type="checkbox"
                        (change)="onCheckboxChange($event,contrato.contrato_id)"
                      />
                    </td>
                    <td>
                      <span class="color-org">
                        {{contrato.numero_contrato}}
                      </span>
                    </td>
                    <td>
                      <span class="color-org">
                        {{ contrato.orden_compra }}
                      </span>
                    </td>
                    <td>
                      <span class="color-org">
                        {{ contrato.oportunidades?.cuenta?.nombre_empresa }}
                      </span>
                    </td>
                    <td>{{contrato.fecha_inicio | date:'dd/MM/yyyy'}}</td>
                    <td>{{contrato.fecha_expiracion | date:'dd/MM/yyyy'}}</td>
                                        <td class="text-center">
                      <span
                        [ngClass]="{
                          'status-borrador': contrato.estado === 'Borrador',
                          'status-aprobacion': contrato.estado === 'En proceso de aprobación',
                          'status-activado': contrato.estado === 'Activado',
                        }"
                      >
                        {{ contrato.estado }}
                      </span>
                    </td>
                    <td>{{contrato.duracion_meses}} meses</td>
                    <td>
                      {{contrato.recordatorio_valor}}
                      {{contrato.recordatorio_unidad}}
                    </td>
                    <td>
                      <span class="color-org">
                        {{ contrato.oportunidades?.cuenta?.ejecutivo?.nombre }}
                        {{ contrato.oportunidades?.cuenta?.ejecutivo?.apellido
                        }}
                      </span>
                    </td>
                    <td class="actions-cell">
                      <div
                        class="dropdown-container"
                        (click)="$event.stopPropagation()"
                      >
                        <button
                          class="dots-button"
                          (click)="toggleActionsMenu('menu-' + contrato.id)"
                        >
                          <svg class="dots-icon" viewBox="0 0 24 24">
                            <circle cx="12" cy="5" r="2" />
                            <circle cx="12" cy="12" r="2" />
                            <circle cx="12" cy="19" r="2" />
                          </svg>
                        </button>
                        <div
                          class="dropdown-menu"
                          [class.show]="openedMenuId === 'menu-' + contrato.id"
                        >
                          <button
                          *ngIf="permissionService.hasPermission('Contratos','Editar')"
                            class="dropdown-item"
                            (click)="openmdlupdateContract(contrato)"
                          >
                            Modificar
                          </button>
                          <button class="dropdown-item">Descargar</button>
                          <button
                          *ngIf="permissionService.hasPermission('Contratos','Eliminar')"
                            class="dropdown-item"
                            (click)="openmdldeleteContract(contrato.contrato_id)"
                          >
                            Eliminar
                          </button>
                          <button
                          *ngIf="permissionService.hasPermission('Contratos','Editar')"
                          class="dropdown-item"
                          (click)="openChangeOwnerModal(contrato)">
                            Cambiar propietario
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            *ngIf="!isLoading && contratos.length === 0 && !errorMessage"
            class="empty-state"
          >
            <div class="empty-content">
              <div class="empty-image">
                <img
                  src="assets/img/listaprospecto.png"
                  alt="Lista de prospectos vacía"
                />
              </div>
              <h2>Sin tareas por ahora</h2>
              <p>
                Todavía no tienes tareas registrados. Puedes comenzar agregando
                una nueva.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
